import {
  SEARCH_CUSTOMER_START,
  SEARCH_CUSTOMER_SUCCESS,
  SEARCH_CUSTOMER_ERROR,
} from "Constant/RentalCustomer";

const initialState = {
  loading: false,
  data: [],
};

export default function searchCustomerReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case SEARCH_CUSTOMER_START:
      return {
        ...state,
        data: [],
        loading: true,
      };
    case SEARCH_CUSTOMER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case SEARCH_CUSTOMER_ERROR:
      return {
        ...state,
        loading: false,
        data: [],
        message: action.error.message,
      };
    default:
      return state;
  }
}
